import React from "react";
import { Icon } from "@bookingcom/bui-react";
import FlightDetailsAncillaryItemLayout from "../../../../../FlightDetailsAncillaryItemLayout";
import useExtraProductsInfo2Controller from "./ExtraProductsInfo2.controller";
import { BagHoldNotAvailableIcon } from "@bookingcom/bui-assets-react/streamline";
import { UIFlightData } from "@flights/types";

const useExtraProductsInfo2 = (flight: UIFlightData) => {
  const { header, baggageText } = useExtraProductsInfo2Controller(flight);

  if (!baggageText) return undefined;

  return {
    header,
    content: (
      <FlightDetailsAncillaryItemLayout
        icon={<Icon size="large" svg={BagHoldNotAvailableIcon} />}
        content={<div dangerouslySetInnerHTML={{ __html: baggageText }}></div>}
        hideIncludedSection={true}
      />
    )
  };
};

export default useExtraProductsInfo2;
